if(!customElements.get('in-the-wild')) {
  class InTheWild extends HTMLElement {
    constructor() {
      super();
      this.onShopCtaClick = this.onShopCtaClick.bind(this);
    }
  
    connectedCallback() {
      this.init();
    }
  
    disconnectedCallback() {
      this.destroySlick($(this.querySelector('.itw-mobile-gallery-box')));
      this.querySelectorAll('.itw-shop-cta').forEach((cta) => {
        cta.removeEventListener('click', this.onShopCtaClick);
      });
    }
  
    init() {
      this.setupShopCta();

      document.addEventListener('DOMContentLoaded', () => {
        const gallery = this.querySelector('.itw-mobile-gallery-box');
        if (!gallery || gallery.querySelectorAll('.itw-mobile-slide').length < 2) return;

        this.initSlick($(gallery));

      });
    }

    setupShopCta() {
      this.querySelectorAll('.itw-shop-cta').forEach((cta) => {
        cta.addEventListener('click', this.onShopCtaClick);
      });
    }

    onShopCtaClick(event) {
      const href = event.currentTarget.getAttribute('href');
      if (!href || href.indexOf('#') !== 0) return;

      const targetId = href.slice(1);
      if (!targetId) return;

      event.preventDefault();

      const target = document.getElementById(targetId);
      if (!target) return;

      const announceBarHeight = document.querySelector('.announcement-bar-section')?.clientHeight || 0;
      const headerHeight = document.querySelector('.section-header')?.clientHeight || 0;
      const barHeight = document.querySelector('common-scroll-to-bar .stb__item-list, scroll-to-bar .stb__item-list')?.clientHeight || 0;
      const headerBarTotalHeight = announceBarHeight + headerHeight + barHeight;

      // history.pushState(null, null, href);

      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + ($(window).scrollTop() || document.documentElement.scrollTop) - headerBarTotalHeight + 10;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  
    initSlick(itwBox = $(this.querySelector('.itw-mobile-gallery-box'))) {
      itwBox.slick({
        infinite: true,
        draggable: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        dots: true
      });
    }
  
    destroySlick(itwBox = $(this.querySelector('.itw-mobile-gallery-box'))) {
      if (itwBox.hasClass('slick-initialized')) {
        itwBox.slick('unslick');
      }
    }
  }
  
  // 注册自定义元素
  customElements.define('in-the-wild', InTheWild);
}
